import { All, HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface, ImpactCardInterface } from '../../types/global';
import { ImpactArea, ImpactCard, SnapshotWardRequest } from '../../api-models';
import { adaptBackendFilters } from '../../utils/filters';
import customIcons from '../../utils/icons';

export default class PostImpactCardData extends BaseAdapter<ImpactCard[]> implements AdapterInterface {
  rawResponse: ImpactCard[];

  modifiedRequest: SnapshotWardRequest;

  async adaptResponse(request: { snapshot: string, liftDataId: string, wardName: string }): Promise<ImpactCardInterface[]> {
    await this.fetchApiResponse('/api/card/impact/list', HTTPMethod.Post, this.adaptRequest(request));
    return this.rawResponse.map((card: ImpactCard) => ({
      title: card.title,
      icon: card.icon.length > 0 ? customIcons[card.icon as keyof typeof customIcons] : undefined,
      url: card.redirect_url.length > 0 ? card.redirect_url : undefined,
      impactAreas: card.impact_areas.map((area: ImpactArea) => ({
        title: area.title,
        value: area.value,
        filters: area.filters.length < 1 ? null : adaptBackendFilters(area.filters),
        description: area.description,
        descriptionFilters: area.description_filters.length < 1 ? null : adaptBackendFilters(area.description_filters),
        variance: area.variance,
        trend: area.trend,
      })),
    }));
  }

  adaptRequest(request: { snapshot: string, liftDataId: string, wardName: string }): SnapshotWardRequest {
    const liftDataId = request.liftDataId === String(All.value) ? null : Number(request.liftDataId);
    this.modifiedRequest = {
      snapshot: request.snapshot,
      lift_data_id: liftDataId,
      ward_name: request.wardName,
    };

    return this.modifiedRequest;
  }
}
